import { useDealConnectStore } from '@/piniaStores/dealConnectStore'
import { useCompaniesStore } from '@/piniaStores/companiesStore'

// Fetches the client's deals and records which companies have them against the companies store.
// Returns whether that index is safe to read. Failed or discarded fetches leave any previous index in place
// and returns false when nothing has loaded yet, so callers do not treat a failure as "no deals".
export function loadDealConnectDeals(): Promise<boolean> {
  const companiesStore = useCompaniesStore()
  let pending = companiesStore.loadingDealConnectDeals
  if (!pending) {
    pending = recordDealConnectDeals().finally(() => {
      if (companiesStore.loadingDealConnectDeals === pending) {
        companiesStore.loadingDealConnectDeals = null
      }
    })
    companiesStore.loadingDealConnectDeals = pending
  }
  return pending
}

async function recordDealConnectDeals(): Promise<boolean> {
  const dealConnectStore = useDealConnectStore()
  const companiesStore = useCompaniesStore()
  if (dealConnectStore.viewAsClientId) {
    return companiesStore.dealConnectDealsLoaded
  }
  const applied = await dealConnectStore.fetchDeals()
  if (!applied || dealConnectStore.viewAsClientId) {
    return companiesStore.dealConnectDealsLoaded
  }
  const companyIdsWithDeals = [...new Set(dealConnectStore.deals.flatMap((deal) => deal.companyId ?? []))]
  companiesStore.setDealConnectDeals(companyIdsWithDeals, dealConnectStore.deals.length > 0)
  return companiesStore.dealConnectDealsLoaded
}
